import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import AccessDenied from "@/views/AccessDenied.vue";
import AuthServiceFactory from '@/services/authentication/AuthServiceFactory';
import OidcCallback from "@/authentication/OIDC/OidcCallback.vue";
import SilentRenew from "@/authentication/OIDC/SilentRenewOIDC.vue";
import SignInOIDCError from "@/authentication/OIDC/SignInOIDCError.vue";
/* Accounting Modules */
import ManualPayment from '@/views/accounting/ManualPayment.vue';
import Customers from "@/views/accounting/Customers.vue";
import ConfigioPaymentJobs from "@/views/accounting/ConfigioPaymentJobHistory.vue";
import TransactionHistory from "@/views/accounting/TransactionHistory.vue";
/* Document Management Modules */
import FileExplorer from '@/views/document-management/FileExplorer.vue';
/* Profile Modules */
import Profile from "@/views/user/Profile.vue";
/* Global Modules */
import SearchResults from '@/views/search/SearchResults.vue';
Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
        meta: {
            title: "Testing",
            requiresAuth: false,
            layout: "material"
        }
    },
    {
        path: "/user/profile",
        name: "My Profile",
        component: Profile,
        meta: {
            title: "My Profile",
            requiresAuth: true,
            layout: "material"
        }
    },
    {
        path: "/about",
        name: "about",
        component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
        meta: {
            title: "Testing",
            requiresAuth: false,
            layout: "material"
        }
    },
    {
        path: "/oidc-callback",
        name: "oidc-callback",
        component: OidcCallback,
        meta: {
            isOidcCallback: true,
            title: "Testing",
            isPublic: true
        }
    },
    {
        path: "/oidc-silent-renew",
        name: "oidc-silent-renew",
        component: SilentRenew,
        meta: {
            title: "Testing",
            isPublic: true
        }
    },
    {
        path: "/signin-oidc-error",
        name: "signin-oidc-error",
        component: SignInOIDCError,
        meta: {
            title: "Sign In Error",
            isPublic: true
        }
    },
    {
        path: "/access-denied",
        name: "access-denied",
        component: AccessDenied,
        meta: {
            title: "Access Denied",
            requiresAuth: false,
            layout: "material"
        }
    },
    {
        path: "/accounting/configio-payment-jobs",
        name: "ConfigioPaymentJobs",
        component: ConfigioPaymentJobs,
        meta: {
            title: "Payment Job History",
            requiresAuth: false,
            roles: ["accounting"],
            layout: "material"
        }
    },
    {
        path: "/accounting/transaction-history",
        name: "TransactionHistory",
        component: TransactionHistory,
        meta: {
            title: "Transaction History",
            requiresAuth: false,
            roles: ["accounting"],
            layout: "material"
        }
    },
    {
        path: "/accounting/manual-payments",
        name: "Manual Payments",
        component: ManualPayment,
        meta: {
            title: "Manual Payments",
            requiresAuth: true,
            roles: ["accounting"],
            layout: "material"
        }
    },
    {
        path: "/accounting/customers",
        name: "Customers",
        component: Customers,
        meta: {
            title: "Customers",
            requiresAuth: true,
            roles: ["accounting"],
            layout: "material"
        }
    },
    {
        path: "/search/results/:searchTerm",
        name: "SearchResults",
        component: SearchResults,
        meta: {
            title: "Search Results",
            requiresAuth: false,
            layout: "material"
        }
    },
    {
        path: "/document-management/file-explorer",
        name: "FileExplorer",
        component: FileExplorer,
        meta: {
            title: "Document Explorer",
            requiresAuth: false,
            layout: "material"
        }
    },
    {
        path: "/document-management/file-explorer",
        name: "FileExplorer2",
        component: FileExplorer,
        meta: {
            title: "Document Explorer",
            requiresAuth: false,
            layout: "material"
        }
    }
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
router.beforeEach(async (to, from, next) => {
    const requiresAuthentication = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuthentication === true) {
        const authService = AuthServiceFactory.GetAuthService();
        if (await authService.isLoggedIn() === true) {
            let accessAllowed = await authService.accessAllowed(to.meta.roles);
            if (accessAllowed === true) {
                next();
            }
            else {
                next('/access-denied');
            }
        }
        else {
            await authService.login();
        }
    }
    else {
        next();
    }
});
export default router;
